import ThirdPartyComponentsViewViewModelT from '@/Components/ThirdPartyComponentsView/ThirdPartyComponentsViewViewModel';
import ThirdPartyComponentsViewT from '@/Components/ThirdPartyComponentsView/ThirdPartyComponentsView';
import ViewFactory from '@/Factories/ViewFactory';
import ComponentManager from '@/Management/ComponentManager';
import * as Interfaces from '#/CoreFrameInterfaces';

export default class ThirdPartyComponentsViewFactory extends ViewFactory {
    private ThirdPartyComponentsViewViewModel = ComponentManager.getViewModel<typeof ThirdPartyComponentsViewViewModelT>('ThirdPartyComponentsViewViewModel');
    private ThirdPartyComponentsView = ComponentManager.getView<typeof ThirdPartyComponentsViewT>('ThirdPartyComponentsView');

    public viewModel: ThirdPartyComponentsViewViewModelT;
    public view: ThirdPartyComponentsViewT;
    private onOpen: Function;
    private onClose: Function;

    constructor(params: Interfaces.IThirdPartyComponentsViewFactoryConstructorParameter) {
        super(params);

        this.onOpen = this.handlerOrDefault(params.onOpen);
        this.onClose = this.handlerOrDefault(params.onClose);
    }

    public getRegion(): string {
        return 'Modal';
    }

    public getView(): JQuery<HTMLElement> {
        if (this.viewModel == null) {
            this.viewModel = new this.ThirdPartyComponentsViewViewModel({
                locator: this.locator,
                viewFactory: this,
                onOpen: this.onOpen,
                onClose: this.onClose
            });
        }

        if (this.view == null) {
            this.view = new this.ThirdPartyComponentsView(this.viewModel, this.createRootElement('ThirdPartyComponentsView'));
        }

        let tuple = this.view.getTuple();
        return tuple.view;
    }
}

ComponentManager.setFactory('ThirdPartyComponentsView', ThirdPartyComponentsViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');